import 'css-chunksrc/client/scenes/wbs/milestone/styles.scss';export default {
  "milestone": "_milestone_g3m1f_1",
  "contextualMenu": "_contextualMenu_g3m1f_7",
  "milestoneDetails": "_milestoneDetails_g3m1f_11",
  "name": "_name_g3m1f_18",
  "icon": "_icon_g3m1f_32",
  "taskAdvancement": "_taskAdvancement_g3m1f_36",
  "taskAdvancementWrapper": "_taskAdvancementWrapper_g3m1f_42",
  "removeIcon": "_removeIcon_g3m1f_55",
  "status": "_status_g3m1f_59",
  "allocations": "_allocations_g3m1f_67",
  "text": "_text_g3m1f_74",
  "tick": "_tick_g3m1f_80",
  "completed": "_completed_g3m1f_87",
  "displayContextualMenu": "_displayContextualMenu_g3m1f_98",
  "placeholder": "_placeholder_g3m1f_102",
  "milestoneCompletion": "_milestoneCompletion_g3m1f_107",
  "completionDate": "_completionDate_g3m1f_114",
  "constrained": "_constrained_g3m1f_120",
  "allocated": "_allocated_g3m1f_124",
  "constraintsPopup": "_constraintsPopup_g3m1f_128"
};